<div data-cy="residents-migrateid-popup__page" class="gd-modal">
  <h1 mat-dialog-title>Omwonende upgraden naar stakeholder</h1>
  <div mat-dialog-content>
    <p>Je staat op het punt om deze omwonende/bedrijf te upgraden naar een stakeholder. Alle gegevens van dit item worden daarmee verplaatst naar het stakeholderoverzicht.</p>
    <p>Na het voltooien van de upgrade is de omwonende niet meer zichtbaar in Dialog. Deze handeling is niet omkeerbaar.</p>
    <p>Selecteer welk type de omwonenden als stakeholder moeten krijgen.</p>
    <label for="stakeholder-type">Type*</label>

    <form data-cy="residents-migrateid-popup__stake-holder-form-form" [formGroup]="StakeHolderForm" (ngSubmit)="migrateIDResidents(StakeHolderForm.value)">
      <div class="gd-migrate-form">
        <div mat-form-field>
          <mat-select placeholder="Select" id="stakeholder-type" name="id" formControlName="type_id" [ngClass]="{ 'is-invalid': submitted && f.type_id.errors }">
            <mat-option *ngFor="let type of DataTypesStakeholder; trackBy: trackByFn" [value]="type.id">{{ type.name }}</mat-option>
          </mat-select>
        </div>
      </div>

      <div *ngIf="submitted && f.type_id.errors" class="invalid-feedback">
        <p class="d-error help-block">Selecteer welk type de omwonende als stakeholder moeten krijgen</p>
      </div>

      <mat-dialog-actions data-cy="residents-migrateid-popup__dialog-actions" align="end">
        <button data-cy="residents-migrateid-popup__submit-btn" color="primary" type="submit" mat-button>
          <p style="margin: 0 10px 0 10px">
              Upgrade deze omwonende
          </p>
        </button>
      </mat-dialog-actions>
    </form>
  </div>
</div>
